'use client'

import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { type ReactNode, useEffect, useLayoutEffect } from 'react'

import { WindowListeners } from '@/components/layout/WindowListeners'
import { useReduxSelector } from '@/store/hooks'
import { initCookies } from '@/utils/cookieUtil'

import styles from './Site.module.scss'

type Props = {
  children: ReactNode
}

export const Site = ({ children }: Props) => {
  const mobileStatus = useReduxSelector((s) => s.view.mobileStatus)

  const isLockedMobile = mobileStatus !== 'closed'

  // Required here for 404s
  useLayoutEffect(() => {
    initCookies()
  }, [])

  useLayoutEffect(() => {
    if (isLockedMobile) document.body.classList.add('isLockedMobile')
    else document.body.classList.remove('isLockedMobile')

    return () => document.body.classList.remove('isLockedMobile')
  }, [isLockedMobile])

  // Marks the page as ready for CSS transitions
  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      document.documentElement.dataset.ready = ''
    })

    return () => cancelAnimationFrame(frame)
  }, [])

  return (
    <div className={styles.container}>
      <WindowListeners />
      {children}
      <ReactQueryDevtools />
    </div>
  )
}
